import React, { useContext, useState } from "react";
import { Button, Row, Col, ListGroup, Form } from "react-bootstrap";
import DataGrid, { SelectColumn } from "react-data-grid";
import { Typeahead, ClearButton } from "react-bootstrap-typeahead";

import StoryContext from "../store/context";
import { observer } from "mobx-react-lite";

const columnsProduct = [SelectColumn, { name: "Найменування", key: "name" }];

const sorted = (A, B) => (A.name < B.name ? -1 : 1);

function rowKeyGetter(row) {
  // console.log(JSON.stringify(row))
  return row.uuid;
}

const ReportSalary = observer(() => {
  const store = useContext(StoryContext);

  const onChangeSelect = (item) => {
    if (item[0]) {
      store.reportSalary.setCurrentTeam(item[0].id);
    } else {
      store.reportSalary.setCurrentTeam(null);
    }
  };
  const onSelectedRowsChange = (t) => {
    // console.log(t);
    // setSelectedRows(t)
  };
  // console.log(store);
  return (
    <>
      <Row>
        <Col>
          <input
            name="requested_order_ship_date"
            value={store.reportSalary.date1}
            type="date"
            className="form-control"
            onChange={(event) =>
              store.reportSalary.setDate1(event.target.value)
            }
          />
        </Col>
        <Col>
          <input
            name="requested_order_ship_date"
            value={store.reportSalary.date2}
            type="date"
            className="form-control"
            onChange={(event) =>
              store.reportSalary.setDate2(event.target.value)
            }
          />
        </Col>
        <Col>
          <Button onClick={() => store.reportSalary.setExcel()}>
            Сформувати
          </Button>
        </Col>
      </Row>
      <br />
    </>
  );
});

export default ReportSalary;
